/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { computed } from '@ember/object';

export default class ChangelogController extends Controller {
  timestampFormat = 'MMMM D, YYYY [at] HH:mm';

  @computed('model.result.createTime')
  get algorithmVersion() {
    if (this.get('model.result.createTime') < 1600315200) {
      // Predates 4pm on September 17, 2020.
      return 1;
    }
    return 2;
  }
}
